export default "__VITE_ASSET__06ad7426__"